import React from 'react';
import StepProgressBar, { Step } from './StepProgressBar';
import useLaunchProjectNavigator from './launchProjectNavigator';

export interface LaunchProjectStepsProps {
  currentStep: 1 | 2 | 3 | 4;
}

export default function LaunchProjectSteps(props: LaunchProjectStepsProps) {
  const projectLaunchNavigator = useLaunchProjectNavigator();

  const steps: Step[] = [
    {
      name: 'Add / Update Details',
      onClick: () => projectLaunchNavigator.openUpdateProjectPage(),
    },
    {
      name: 'Edit Key Dates',
      onClick: () => projectLaunchNavigator.openKeyDateTasksPage(),
    },
    {
      name: 'Edit All Tasks',
      onClick: () => projectLaunchNavigator.openAllTasksPage(),
    },
    {
      name: 'Add Transaction Parties',
      onClick: () => projectLaunchNavigator.openTransactionPartiesPage(),
    },
  ];
  return (
    <StepProgressBar steps={steps} currentStep={props.currentStep} />
  );
}
